jQuery(function () {
	var $form = jQuery('form#wholesaleForm'),
	url = 'https://script.google.com/macros/s/AKfycbyA2x-6rznqgWq8XTCS0Akwg8zdt5ZVvhb8WOY79Abcl_vq2-sOmpCb/exec';

	jQuery('#wholesaleForm').submit(function (e) {
		$('#submit-form').replaceWith('<button id="submit-form" class="btn btn-primary btn-lg btn-block" type="button" disabled>  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>  Submitting...</button>');

		e.preventDefault();
		var jqxhr = jQuery
			.ajax({
				url: url,
				method: 'GET',
				dataType: 'json',
				data: jQuery(this).serialize(),
			})
			.done(function (html) {
				// do something
				$('#submit-form').replaceWith('<button type="submit" class="btn btn-primary btn-lg btn-block" id="submit-form">Submit</button>');
				$('#output').html('<div class="alert alert-success" role="alert">Thanks, we have received your request and will be in contact as soon as possible!</div>');
				$('#wholesaleForm').trigger('reset');
			})
			.fail(function () {
				$('#submit-form').replaceWith('<button type="submit" class="btn btn-danger btn-lg btn-block" id="submit-form" disabled>Error</button>');
				$('#output').html('<div class="alert alert-danger" role="alert">Uhh ohh, something went wrong. Please contact our support team at support@kulgrilles.com</div>');
			});
	});
});
